var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.511 2.634c-.998.07-2.165.708-2.846 1.54-.62.756-1.13 1.877-.931 2.967 1.09.034 2.218-.62 2.871-1.467.611-.787 1.074-1.902.906-3.04Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.458 8.919c-.959-1.203-2.306-1.9-3.579-1.9-1.68 0-2.39.804-3.558.804-1.203 0-2.118-.802-3.57-.802-1.428 0-2.947.872-3.91 2.364-1.355 2.1-1.124 6.049 1.072 9.412.785 1.204 1.834 2.557 3.206 2.569 1.221.012 1.565-.783 3.22-.792 1.654-.009 1.968.802 3.186.79 1.374-.011 2.48-1.51 3.266-2.714.563-.863.772-1.297 1.209-2.271-3.176-1.21-3.686-5.727-.542-7.46Z",
    fill: "#fff"
  })));
};
export default SvgApple;